import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import Icon from '../../ui/Icon';
import styles from './PrintButton.module.scss';

export default function PrintButton(props) {
  return (
    <Tooltip
      content={props.tooltipText}
      distance="15"
      interactive={false}
      placement={props.placement}
      size="medium"
      theme={props.tippyTheme}
    >
      <a
        aria-label={props.tooltipText}
        className={styles[props.wrapperClass]}
        href={props.pdfPath}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon icon="Print" size={30} />
        <span className="sr-only">{props.tooltipText}</span>
      </a>
    </Tooltip>
  );
}

PrintButton.propTypes = {
  pdfPath: PropTypes.string.isRequired,
  placement: PropTypes.string,
  tippyTheme: PropTypes.string,
  tooltipText: PropTypes.string,
  wrapperClass: PropTypes.string
};

PrintButton.defaultProps = {
  placement: 'top',
  tippyTheme: 'white',
  tooltipText: 'Print Text',
  wrapperClass: ''
};
